const CtaState = {
    ADD_TO_CART: 'ADD_TO_CART',
    APPOINTMENT: 'APPOINTMENT',
    AVAILABILITY_ALERT: 'AVAILABILITY_ALERT',
    DEALER_SEARCH: 'DEALER_SEARCH',
    PRODUCT_SOLD_OUT: 'PRODUCT_SOLD_OUT',
    PRODUCT_UNAVAILABLE: 'PRODUCT_UNAVAILABLE',
    VARIANT_SOLD_OUT: 'VARIANT_SOLD_OUT',
    VARIANT_UNAVAILABLE: 'VARIANT_UNAVAILABLE',
};

export { CtaState };
